import { render, staticRenderFns } from "./EditAuthor.vue?vue&type=template&id=502bdd06&scoped=true&"
import script from "./EditAuthor.vue?vue&type=script&lang=js&"
export * from "./EditAuthor.vue?vue&type=script&lang=js&"
import style0 from "./EditAuthor.vue?vue&type=style&index=0&id=502bdd06&lang=scss&scoped=true&"
import style1 from "./EditAuthor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502bdd06",
  null
  
)

export default component.exports